import type { Attachment } from '../../../features/chat/api';

export const buildAttachmentBatchId = () =>
  `report-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

const isImageAttachment = (attachment: Attachment) =>
  attachment.mediaKind === 'image' || attachment.mimeType.startsWith('image/');

export const withAttachmentGrouping = (
  attachments: Attachment[],
  buildBatchId = buildAttachmentBatchId,
): Attachment[] => {
  if (attachments.length === 0) return attachments;
  if (attachments.length === 1) return [{ ...attachments[0], fileOrder: 0 }];
  if (!attachments.every(isImageAttachment)) {
    return attachments.map((attachment, index) => ({ ...attachment, fileOrder: index }));
  }

  const groupId = buildBatchId();
  return attachments.map((attachment, index) => ({
    ...attachment,
    groupId,
    fileOrder: index,
  }));
};
